
























































import { Component, Vue} from 'vue-property-decorator'
import REPORT_COLUMNS from '@/config/reportForm/column-config/dis-sort-details'
import { setSessionStorage } from '../../../store/src/utils/index'
@Component
export default class Login extends Vue {
	private reportFormId: string = 'PSFJ_10001'
	private settingCols: any = REPORT_COLUMNS
	private gridData: any = []
	private hideCols: string = ''
	private sumCol: any = {}
	private dateValue: any = []
	private billState: string = ''
	private filterFormData: any = {
		dateType: '0',
		restaurantName: '',
		fromOrganName: '',
		toOrganName: '',
		goodsName: '',
		billState: []
	}
	private onChangeColData (hideCol: string) {
		this.hideCols = hideCol
	}
	private async onSearch () {
		const searchFilter = await this.searchFilter('1')
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			ediExportHideCols: '1'
		}
		await this.initTableData(params)
		await this.searchHandler(searchFilter)
	}
	private searchFilter (ediExportParams?: string) {
		return new Promise((resolve: any) => {
			const settingMenuParams = this.settingCols.map((item) => {
				return item.prop
			})
			const params = {
				filters: {rules: this.getFiltersParams().filtersParams},
				rows: 30,
				page: 1,
				validcols: settingMenuParams.join(','),
				ediExportHideCols: ediExportParams
			}
			resolve(params)
		})
	}
	private searchHandler (params) {
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getGHSFJ10001DataChoose',
				data: params
			}).then((res: any) => {
				if (params.ediExportHideCols === '1') {
					this.setGridData(res)
				}
				resolve()
			})
		})
	}
	private onExport () {
		this.exportFun()
	}
	private async exportFun () {
		const hideCols = this.hideCols
		const searchFilter = await this.searchFilter(hideCols)
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			ediExportHideCols: ''
		}
		await this.initTableData(params)
		const searchHandler = await this.searchHandler(searchFilter)
		await this.exportHandler(searchHandler)
	}
	private exportHandler (params) {
		window.open('/cldEdi/reportDateController/exportEdiDataCommon.do?exportType=5')
	}
	private onSortChange ({ prop, order }) {
		const settingMenuParams = this.settingCols.map((item) => {
			return item.prop
		})
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			rows: 30,
			page: 1,
			validcols: settingMenuParams.join(','),
			sord: prop === null ? null : order === 'ascending' ? 'asc' : 'desc',
			sidx: prop
		}
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getGHSFJ10001DataChoose',
				data: params,
				loading: true
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private setGridData (gridObj) {
		this.gridData = gridObj.currentData || []
		this.sumCol = gridObj.userdata || {}
	}
	private created () {
		setSessionStorage('titleLabel', '配送分拣表')
		this.initFilters()
		this.initTableData()
	}
	private initTableData (params?: any) {
		return (this as any).$fxHttp.requestPost({
			url: '/reportDateController/getGHSFJ10001ConfigChoose',
			data: params
		}).then((res: any) => {
			if (params && params.ediExportHideCols === '1') {
				this.settingCols = res.currentData
			}
			return Promise.resolve()
		})
	}
	private initFilters () {
		this.dateValue = [(this as any).$fxCommon.orderFilterStartDate(), (this as any).$fxCommon.orderFilterEndDate()]
	}
	private getFiltersParams () {
		const filtersParams = [] as any
		if (this.filterFormData.dateType !== '') {
			const dateType = { field: 'date_type', data: this.filterFormData.dateType, op: 'eq' }
			filtersParams.push(dateType)
		}
		if (this.filterFormData.restaurantName) {
			const restaurantName = { field: 'restaurant_name', data: this.filterFormData.restaurantName, op: 'cn' }
			filtersParams.push(restaurantName)
		}
		if (this.filterFormData.fromOrganName) {
			const fromOrganName = { field: 'from_organ_name', data: this.filterFormData.fromOrganName, op: 'cn' }
			filtersParams.push(fromOrganName)
		}
		if (this.filterFormData.toOrganName) {
			const toOrganName = { field: 'to_organ_name', data: this.filterFormData.toOrganName, op: 'cn' }
			filtersParams.push(toOrganName)
		}
		if (this.filterFormData.goodsName) {
			const goodsName = { field: 'goods_name', data: this.filterFormData.goodsName, op: 'cn' }
			filtersParams.push(goodsName)
		}
		if (this.filterFormData.billState.length) {
			const billState = { field: 'billState', data: this.filterFormData.billState, op: 'cn' }
			filtersParams.push(billState)
		}
		if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
			filtersParams.push(
					{ field: 'from_date', data: `${(this as any).$fxCommon.orderFilterStartDate()} 00:00`, op: 'ge' },
					{ field: 'from_date', data: `${(this as any).$fxCommon.orderFilterEndDate()} 23:59`, op: 'le' }
			)
		} else {
			filtersParams.push(
					{ field: 'from_date', data: `${this.dateValue[0]} 00:00`, op: 'ge' },
					{ field: 'from_date', data: `${this.dateValue[1]} 23:59`, op: 'le' }
			)
		}
		return {
			filtersParams
		}
	}
}
